import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import Modal from 'src/components/customModal';
import { FormProvider } from 'src/components/hook-form';
import { extractBidValue, formatBidValue } from 'src/utils/formatBid';
import { handleCloseModal } from 'src/utils/propertyHelpers';
import { dispatch, useSelector } from 'src/redux/store';
import { setAskPrice } from 'src/redux/slices/transaction';
import { selectModal } from 'src/redux/slices/modal';
import modals from 'src/constants/modals';
import PriceField from 'src/components/PriceField';
import { LoadingButtonStyledOffer, SubtitleStyled, TitleStyled } from './style';
import { validationMakeAnOffer } from './validationSchemas';

const Content = () => {
	const { payload } = useSelector(selectModal<{ price?: number }>);
	const { enqueueSnackbar } = useSnackbar();

	const methods = useForm({
		resolver: yupResolver(validationMakeAnOffer),
		values: { offer: payload.price ? formatBidValue(`${payload.price}`) : '' },
	});

	const {
		handleSubmit,
		formState: { isSubmitting },
	} = methods;

	const onSubmit = async (data) => {
		try {
			await dispatch(setAskPrice({ price: extractBidValue(data.offer) }));

			enqueueSnackbar('Your ask price has been submitted', { variant: 'success' });
			handleCloseModal();
		} catch (e) {
			console.error(e);
			enqueueSnackbar('Something went wrong while submitting your ask price', { variant: 'error' });
		}
	};

	return (
		<FormProvider methods={methods} onSubmit={onSubmit}>
			<TitleStyled>ENTER ASK PRICE</TitleStyled>
			<SubtitleStyled>This is the price at which you wish to market your property.</SubtitleStyled>
			<PriceField name='offer' />
			<LoadingButtonStyledOffer loading={isSubmitting} onClick={handleSubmit(onSubmit)} variant='contained'>
				Submit
			</LoadingButtonStyledOffer>
		</FormProvider>
	);
};

export const AskPriceModal = () => (
	<Modal name={modals.askPrice} cardSx={{ maxWidth: '500px' }}>
		<Content />
	</Modal>
);
